export default __webpack_public_path__ + "static/4-d0af68b0012ccb62237dcaa82f2dd4d4.jpeg";